import { donedealBreakpoints } from 'styled-system';

/**
 * @deprecated Use typeof donedealBreakpoints.media from 'styled-system';
 */
export type Media = typeof donedealBreakpoints.media;

/**
 * @deprecated Use donedealBreakpoints.media from 'styled-system';
 */
export const media = donedealBreakpoints.media;

/**
 * @deprecated Use donedealBreakpoints.matchMedia from 'styled-system';
 */
export const matchMedia = donedealBreakpoints.matchMedia;

/**
 * @deprecated Use donedealBreakpoints.matchMedia from 'styled-system';
 */
export const SCREEN_LARGE = 60 * 16;

/**
 * @deprecated Use donedealBreakpoints.matchMedia from 'styled-system';
 */
export const SCREEN_XLARGE = 64 * 16;
